<template>
    <div class="bookCon">
        <div class="left">
            <div class="book">
                <div class="info">
                    <dl>
                        <dt>
                            <img :src="bookInfo.cover" alt="">
                        </dt>
                        <dd>
                            <h2>{{ bookInfo.name }}</h2>
                            <p>作者：{{ bookInfo.author }}</p>
                            <p>播者：{{ bookInfo.anchor }}</p>
                            <div>
                                <i></i>
                                <p>{{ bookInfo.plays }}</p>
                                <div>共{{ bookInfo.chapters }}章</div>
                            </div>
                        </dd>
                    </dl>
                </div>
                <div class="play_btn" @click="rightAwayplayAudio()">{{ playBtnText }}</div>
            </div>
            <ul class="tab">
                <li v-for="(item, index) in tabList" :key="index" :class="index==tabAct ? 'act' : ''" @click="tab(index)">
                    <div></div>
                    <p>{{ item.name }}</p>
                </li>
            </ul>
            <div class="summary" v-show="!isChapters" v-html="bookInfo.introduction"></div>
            <div class="chapters" v-show="isChapters">
                <ul>
                    <li v-for="(item, index) in chapters" :key="index" :class="actChapterRank == item.sort ? 'act' : ''" @click="playAudio(item, index)">
                        <div class="rank">{{ item.sort }}</div>
                        <i></i>
                        <p>{{ item.name }}</p>
                        <span>{{ commin.fn.setAudioTime(item.duration) }}</span>
                        <i @click.stop="downLoadAudio(item)" v-show="bookInfo.isDownload == 'Y'"></i>
                    </li>
                    <!-- <li>
                        <div class="rank">100</div>
                        <i></i>
                        <p>伟成最帅</p>
                        <span>更新于2019-7-31</span>
                    </li> -->
                </ul>
                <pager :total-page="totalPage" :initPage="pageNum" @go-page="goPageNum" v-if="isShowPager" />
            </div>
        </div>
    </div>
</template>
<script>
import pager from './pager.vue'
export default {
    components: {
        pager
    },
    data() {
        return {
            bookInfo: {},
            playBtnText: "立即播放",
            tabList:[
                {
                    "name": "书籍简介"
                },
                {
                    "name": "章节目录"
                },
            ],
            tabAct: 0,
            isChapters: false,
            pageNum: 1,
            totalPage: 1,
            isShowPager: false,
            chapters: [],
            // historyChapters: [],
            firstChapters: [],
            isHistory: true,
            historyChapter: {},
            historyChapterIdx: -1,
            currentTime: -1,
            actChapterRank: -1,
            draw: true
        }
    },
    computed: {
        bookId() {
            return this.$route.query.id;
        },
        selectedBookInfo(){
            return this.$store.state.bookInfo;
        },
        collectCode(){
            return this.$store.state.collectCode;
        },
        historyCode(){
            return this.$store.state.historyCode;
        },
        actChapter(){
            return this.$store.state.actChapter;
        },
        stateBookInfo(){
            return this.$store.state.bookInfo;
        },
    },
    mounted() {
        let that = this;
        that.bookDetail();
        that.getChapters();
        if( that.bookId == that.stateBookInfo.book ) {
            that.playBtnText = "正在播放";
        }
    },
    methods: {
        bookDetail() {
            let that = this;
            let data = {
                book: that.bookId
            }
            that.allApi.bookDetail(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    that.bookInfo = resource.data.data;
                }
            })
        },
        tab(idx) {
            let that = this;
            that.tabAct = idx;
            if( idx == 0 ) {
                that.isChapters = false;
            }else{
                that.isChapters = true;
            }
        },
        getChapters() {
            let that = this;
            let data = {
                book: that.bookId,
                page: that.pageNum,
                history: true,
                size: 10
            }

            that.allApi.chapterList(data).then((resource) => {
                // console.log(resource.data);
                if( resource.data.code == 200 ) {
                    that.chapters = resource.data.data.page.list;
                    if( that.pageNum == 1 ) {
                        that.firstChapters = resource.data.data.page.list;

                        that.totalPage = resource.data.data.page.pages;
                        if( that.totalPage == 1 ) {
                            that.isShowPager = false;
                        }else{
                            that.isShowPager = true;
                        }
                        that.$store.commit("setTotalPage", that.totalPage);
                        
                        if( resource.data.data.history ) {
                            that.historyChapter = that.chapters[resource.data.data.history.sort-1];
                            that.historyChapterIdx = parseInt( (resource.data.data.history.sort - 1) % 10 ) == 0 ? parseInt( (resource.data.data.history.sort - 1) / 10 ) : parseInt( (resource.data.data.history.sort - 1) % 10 );
                            that.currentTime = resource.data.data.history.duration;
                            that.actChapterRank = resource.data.data.history.sort;
                        }else{
                            that.actChapterRank = 1;
                        }
                    }
                    
                    that.pageNum = resource.data.data.page.page;
                }
            })
        },
        goPageNum(obj) {
            let that = this;
            that.pageNum = obj.page;
            that.isHistory = false;
            that.getChapters();
        },
        rightAwayplayAudio() {
            // 立即播放
            let that = this;
            if( that.playBtnText == "正在播放" ) {
                return false;
            }
            that.playBtnText = "正在播放";

            // if( that.bookInfo.book != that.selectedBookInfo.book || !that.historyCode ) {
            //     that.$store.commit("setHistoryCode", that.bookInfo.history);
            // }
            if( that.bookInfo.id != that.selectedBookInfo.id || !that.collectCode ) {
                that.$store.commit("setCollectCode", that.bookInfo.collect);
            }

            // 有历史播放历史章节，无历史播放第一章
            if( that.historyChapterIdx != -1 ) {
                // 历史章节
                that.$store.commit("setActChapter", that.historyChapter);
                that.$store.commit("setActChapterIdx", that.historyChapterIdx);
                that.$store.commit("setActChapterCurrentTime", that.currentTime);
            }else{
                // 播放第一章
                that.$store.commit("setActChapter", that.firstChapters[0]);
                that.$store.commit("setActChapterIdx", 0);
                that.$store.commit("setActChapterCurrentTime", 0);
            }
            that.$store.commit("setBookInfo", that.bookInfo);
            that.$store.commit("setChapters", that.firstChapters);

            
            // that.$store.commit("setCollectCode", that.bookInfo.collect);
            // that.$store.commit("setHistoryCode", that.bookInfo.history);
        },
        playAudio(item, idx) {
            let that = this;
            // if( that.bookInfo.book != that.selectedBookInfo.book || !that.historyCode ) {
            //     that.$store.commit("setHistoryCode", that.bookInfo.history);
            // }
            if( that.bookInfo.id != that.selectedBookInfo.id || !that.collectCode ) {
                that.$store.commit("setCollectCode", that.bookInfo.collect);
            }
            that.playBtnText = "正在播放";
            that.$store.commit("setActChapter", item);
            that.$store.commit("setActChapterIdx", idx);
            that.$store.commit("setActChapterCurrentTime", 0);
            that.$store.commit("setBookInfo", that.bookInfo);
            that.$store.commit("setChapters", that.chapters);
            
        },
        goBook(bookId) {
            let that = this;
            that.addClickNum();
            that.$router.push({
                path: '/book',
                query: {
                    id: bookId
                }
            })
            that.routerReload();
        },
        addClickNum() {
            let that = this;
            let data = new FormData();
            data.append("dept", localStorage.getItem("dept"));
            data.append("version", localStorage.getItem("version"));
            that.allApi.addClickNum(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    
                }
            })
        },
        routerReload() {
            let that = this;
            that.$store.commit("setIsRouterAlive", false);
            that.$nextTick(()=>{
                that.$store.commit("setIsRouterAlive", true);
            })
        },
    },
    watch: {
        actChapter(newV) {
            let that = this;
            that.actChapterRank = newV.sort;
        },
        stateBookInfo() {

        }
    }
}
</script>
<style lang="scss" scoped>
    .bookCon{
        width: 1200px;
        min-height: 1200px;
        margin: 0 auto;
        overflow: hidden;
        padding-bottom: 50px;
        >.left{
            float: left;
            width: 100%;
            padding-top: 80px;
            >.book{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 52px;
                >.info{
                    width: 0%;
                    flex: 1;
                    min-width: 0;
                    >dl{
                        display: flex;
                        >dt{
                            width: 170px;
                            height: 170px;
                            margin-right: 52px;
                            position: relative;
                            >img{
                                display: block;
                                width: 100%;
                                height: 100%;
                            }
                        }
                        >dd{
                            width: 0%;
                            flex: 1;
                            min-width: 0;
                            >h2{
                                font-size: 26px;
                                @include dominant_color(#1c1c1c);
                                line-height: 38px;
                                font-weight: 500;
                            }
                            >p{
                                @include secondary_color(#999);
                                font-size: 20px;
                                line-height: 30px;
                            }
                            >div{
                                overflow: hidden;
                                line-height: 30px;
                                font-size: 20px;
                                >i{
                                    float: left;
                                    width: 21px;
                                    height: 21px;
                                    margin-top: 4.5px;
                                    margin-right: 5px;
                                    background-position: center;
                                    background-repeat: no-repeat;
                                    background-image: url('../assets/imgs/commin/play_num_black.png');
                                    background-size: 100% 100%;
                                }
                                >p{
                                    float: left;
                                    @include secondary_color(#999);
                                    margin-right: 30px;
                                }
                                >div{
                                    float: left;
                                    @include secondary_color(#999);
                                }
                            }
                        }
                    }
                }
                >.play_btn{
                    width: 160px;
                    height: 74px;
                    line-height: 74px;
                    text-align: center;
                    color: #fff;
                    background: #1AA7E0;
                    border-radius: 74px;
                    margin-left: 30px;
                    font-size: 28px;
                    cursor: pointer;
                }
            }
            >.tab{
                display: flex;
                margin-bottom: 28px;
                >li{
                    margin-right: 10px;
                    padding: 0 26px;
                    position: relative;
                    height: 50px;
                    cursor: pointer;
                    >div{
                        position: absolute;
                        left: 50%;
                        bottom: 0;
                        width: 36px;
                        height: 6px;
                        margin-left: -18px;
                        background: #fff;
                        border-radius: 3px;
                    }
                    >p{
                        font-size: 26px;
                        line-height: 50px;
                        @include dominant_color(#1c1c1c);
                    }
                    &.act{
                        >div{
                            background: #1AA7E0;
                        }
                        >p{
                            @include dominant_color_act(#1AA7E0);
                        }
                    }
                }
            }
            >.summary{
                font-size: 18px;
            }
            >.chapters{
                >ul{
                    >li{
                        padding: 0 10px;
                        display: flex;
                        height: 80px;
                        border-bottom: 1px dashed #B0B0B0;
                        align-items: center;
                        @include dominant_color(#1c1c1c);
                        cursor: pointer;
                        >.rank{
                            font-size: 22px;
                            margin-right: 20px;
                            width: 50px;
                            text-align: center;
                            @include dominant_color(#1c1c1c);
                        }
                        >i:first-of-type{
                            display: block;
                            width: 30px;
                            height: 30px;
                            margin-right: 20px;
                            background-image: url('../assets/imgs/audio/book_stop_btn.png');
                            background-position: center;
                            background-repeat: no-repeat;
                        }
                        >p{
                            width: 0%;
                            flex: 1;
                            font-size: 22px;
                            margin-right: 20px;
                        }
                        >span{
                            font-size: 22px;
                            @include dominant_color(#1c1c1c);
                            margin-right: 20px;
                        }
                        >i:last-of-type{
                            display: block;
                            width: 30px;
                            height: 30px;
                            background-image: url('../assets/imgs/book/download.png');
                            background-position: center;
                            background-repeat: no-repeat;
                        }
                        &.act{
                            @include dominant_color_act(#1AA7E0);
                            >i:first-of-type{
                                background-image: url('../assets/imgs/audio/playing.gif');
                            }
                        }
                        &:hover{
                            @include dominant_color_act(#1AA7E0);
                        }
                    }
                }
            }
        }
    }
</style>
